/* eslint-disable arrow-body-style */
import { API, Auth, Logger } from 'aws-amplify';

const logger = new Logger('DeleteApiService.js');
const DELETE_API_NAME = 'DeleteApiProxy';

/**
 * Request Options to include authorization headers on all requests
 */
const requestOptions = () => {
  logger.debug('requestOptions..');
  return Auth.currentAuthenticatedUser()
    .then((user) => {
      return {
        headers: {
          'Content-Type': 'application/json',
          'idToken': `${user.signInUserSession.idToken.jwtToken}`,
          'x-api-authorization': `${user.signInUserSession.accessToken.jwtToken}`,
        },
      };
    })
    .catch((error) => {
      logger.error('User is not authenticated ', error);
      throw error;
    });
};

/**
 * Request Wrapper to call the request options on all requests
 * @param {*} request
 */
const requestWrapper = (request) => {
  return requestOptions().then((options) => request(options));
};

const deleteVendorItem = (vendorId, vendorItemId) => {
  return requestWrapper((options) => {
    // make api request
    return API.del(DELETE_API_NAME, `/vendors/${vendorId}/vendorItems/${vendorItemId}`, options);
  });
};

export {
  requestWrapper,
  deleteVendorItem
};
